import jQuery from 'jquery';
import { PopOver } from 'rp-prices-component';

import deviceDetect from '../deviceDetect';

const defaultConfig = {
    defaultBookie: 'williamHill',
    mobileBookieLabel: 'Choose bookmaker',
    selectBookieLabel: '.RC-bookieSelection__label',
    selectBookieContainer: '.js-RC-bookieSelection',
    selectBookieSelector: '.js-RC-bookieSelection__popOverBookies__bookie',
    selectedBookieBtnSelector: '.js-RC-bookieSelection__btn',
    selectedBookiesClass: 'RC-bookieSelection__popOverBookies__bookie_selected',
    noPriceClass: 'ui-priceBtn_noPrice',
    popOverConfig: {
        activeClass: 'RC-bookieSelection_active',
        popOverSelector: '.js-RC-bookieSelection',
        openAreaSelectors: ['.js-RC-bookieSelection__btn'],
        closeAreaSelectors: ['.js-RC-bookieSelection__popOverShadow']
    },
    bookies: {
        williamHill: {
            className: 'RC-bookieSelection__bookieIcon_williamHill',
            priceButtonClass: 'ui-priceBtn_williamHill',
            feed: 'WH_OXI',
            id: 'B16'
        },
        bestOdds: {
            className: 'RC-bookieSelection__bookieIcon_bestOdds',
            priceButtonClass: 'ui-priceBtn_bestOdds',
            feed: '#BESTODDS',
            id: 'B0'
        },
        ladbrokes: {
            className: 'RC-bookieSelection__bookieIcon_ladbrokes',
            priceButtonClass: 'ui-priceBtn_ladbrokes',
            feed: 'LADB',
            id: 'B11'
        },
        bet365: {
            className: 'RC-bookieSelection__bookieIcon_bet365',
            priceButtonClass: 'ui-priceBtn_bet365',
            feed: 'BET365',
            id: 'B12'
        },
        coral: {
            className: 'RC-bookieSelection__bookieIcon_coral',
            priceButtonClass: 'ui-priceBtn_coral',
            feed: 'CORAL',
            id: 'B32'
        },
        paddypower: {
            className: 'RC-bookieSelection__bookieIcon_paddypower',
            priceButtonClass: 'RC-priceBtn_paddypower',
            feed: 'PPWR',
            id: 'B8'
        },
        betfair: {
            className: 'RC-bookieSelection__bookieIcon_betfair',
            priceButtonClass: 'RC-priceBtn_betfair',
            feed: 'BETFAIR',
            id: 'BETFAIR'
        },
        '888sport': {
            className: 'RC-bookieSelection__bookieIcon_888sport',
            priceButtonClass: 'ui-priceBtn_888sport',
            feed: '888',
            id: '888'
        },
        betVictor: {
            className: 'RC-bookieSelection__bookieIcon_betVictor',
            priceButtonClass: 'ui-priceBtn_betVictor',
            feed: 'VC',
            id: 'B10'
        },
        sportingBet: {
            className: 'RC-bookieSelection__bookieIcon_sportingBet',
            priceButtonClass: 'ui-priceBtn_sportingBet',
            feed: 'SPORTING INDEX',
            id: 'B2'
        },
        skybet: {
            className: 'RC-bookieSelection__bookieIcon_skybet',
            priceButtonClass: 'ui-priceBtn_skybet',
            feed: 'SURREY',
            id: 'B7'
        },
        boylesport: {
            className: 'RC-bookieSelection__bookieIcon_boylesport',
            priceButtonClass: 'ui-priceBtn_boylesport',
            feed: 'BOLEYSPORTS',
            id: 'B17'
        },
        tote: {
            className: 'RC-bookieSelection__bookieIcon_tote',
            priceButtonClass: 'ui-priceBtn_tote',
            feed: 'TOTE',
            id: 'TOTE'
        },
    },
    feedBookieMap: {
        WH_OXI: 'williamHill',
        '#BESTODDS': 'bestOdds',
        LADB: 'ladbrokes',
        BET365: 'bet365', // Betslip specific
        CORAL: 'coral',
        PPWR: 'paddypower',
        BETFAIR: 'betfair',
        888: '888sport',
        VC: 'betVictor',
        'SPORTING INDEX': 'sportingBet',
        SURREY: 'skybet',
        BOLEYSPORTS: 'boylesport',
        TOTE: 'tote'
    },
    onBookieSelection: null,
    onInit: null
};

export default class BookieSelection {
    constructor(customConfig) {
        this.config = jQuery.extend(true, defaultConfig, customConfig);
        this.bookieSelection = jQuery(this.config.selectBookieSelector);
        this.selectBookieLabel = jQuery(this.config.selectBookieLabel);
        this.selectedBookieBtn = jQuery(this.config.selectedBookieBtnSelector);
        if (!deviceDetect.phone()) {
            this.popOver = new PopOver(this.config.popOverConfig);
        } else {
            this.bookieSelectionContainer = jQuery(this.config.selectBookieContainer);
        }
        this.setSelectedBookieUI(this.config.defaultBookie);
        this.bindEvents();
        if (this.config.onInit instanceof Function) {
            this.config.onInit(this);
        }
    }

    bindEvents() {
        function itemClickHandler(event) {
            const bookmakers = Object.keys(this.config.bookies);
            const selectedBookmaker = jQuery(event.target)
                .closest(this.config.selectBookieSelector)[0];
            const bookmakerName = selectedBookmaker.getAttribute('data-bookie-name');

            bookmakers.forEach((bookmaker) => {
                if (bookmakerName === bookmaker) {
                    this.setSelectedBookie(bookmaker, selectedBookmaker);
                }
            });

            this.popOver.close();
        }

        const onBookieSelection = itemClickHandler.bind(this);

        if (this.bookieSelection.length) {
            Array.from(this.bookieSelection)
                .forEach(item => jQuery(item).on('click', onBookieSelection));
        }
    }

    setBookieUIByFeedName(bookieFeedName) {
        const bookieName = this.config.feedBookieMap[bookieFeedName];

        if (bookieName) {
            this.setSelectedBookieUI(this.config.feedBookieMap[bookieFeedName]);
        } else {
            throw new Error('Bookie feed name not found');
        }
    }

    setSelectedBookie(selectedBookie) {
        if (this.config.onBookieSelection instanceof Function) {
            this.config.onBookieSelection(this, selectedBookie);
        }
    }

    setSelectedBookieUI(selectedBookie, bookieInPop) {
        const bookieInPopUp = bookieInPop ||
            document.querySelector(`.js-${this.config.bookies[selectedBookie].className}`);

        if (deviceDetect.phone()) {
            this.selectBookieLabel.text(this.config.mobileBookieLabel);
        }

        if (this.selectedBookie && this.selectedBookieBtn[0]) {
            this.selectedBookieBtn[0].classList
                .remove(this.config.bookies[this.selectedBookie].className);
        }

        if (this.selectedBookieBtn[0]) {
            this.selectedBookieBtn[0].classList.add(this.config.bookies[selectedBookie].className);
        }

        if (this.selectedBookieElem) {
            this.selectedBookieElem.classList.remove(this.config.selectedBookiesClass);
        }

        if (bookieInPopUp) {
            bookieInPopUp.classList.add(this.config.selectedBookiesClass);
            this.selectedBookieElem = bookieInPopUp;
        }

        this.previouslySelectedBookie = this.selectedBookie;
        this.selectedBookie = selectedBookie;
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/bookieSelection/bookieSelection.js